<div *ngIf="loading$ | async" class="loader-overlay">
  <div class="loader-container">
    <div class="loader-wrapper">
      <div class="loader"></div>
      <div class="logo-container">
        <img class="logo" src="../../../../assets/images/Logo_Small.png" alt="Logo">
      </div>
    </div>
    <p class="loading-text">Loading...</p>
  </div>
</div>